import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';

var _templateObject;
var SelectContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  opacity: ", ";\n  width: 100%;\n  text-align: left;\n  margin-bottom: 1.375rem;\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? '0.4' : '1';
});

export default SelectContainer;
